import React ,{ PropTypes } from 'react';
import {API} from '../../settings.js';
import {ajaxGet} from '../../helpers/apiData.js';
import {FormattedMessage} from 'react-intl';

import EventItem from './EventItem';
import SmallEventCard from './SmallEventCard';
import Error from '../Error';
import PreLoader from '../PreLoader';
import {imagesLoaded} from "../../helpers/imagesLoadCheck";

class EventDetail extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    slug: PropTypes.string,
    view_info: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.category = '';
    this.event = '';
    this.addThis = '';

   // const now = Date.now();
    this.state = {
      data: {start: ''},
      loading: 'loading'
    };
    this.handleLoading = this.handleLoading.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    this.lang = this.props.match.params.lang;
    this.restaurant = this.props.match.params.restaurant;
    this.slug = this.props.slug;

    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);

    ajaxGet(API + this.lang + '/api/' + this.restaurant + '/events/' + this.slug.split("-").pop() + '/', this);

    this.addThis = 'true';

    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    this.props.view_info(
      //title
      (<FormattedMessage id="detail_title">
          {(message) => <span>{message}</span>}
        </FormattedMessage>),
      //view
      'events',
      //back button or not
      true
    );
  }

  //NEED THIS TO FORCE ADDTHIS TO LOAD
  componentDidUpdate(prevState) {
    if (prevState.addthis !== this.addThis) {
      // eslint-disable-next-line
      if (typeof addthis.layers.refresh !== 'undefined') {
        // eslint-disable-next-line
        addthis.layers.refresh();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  handleLoading() {
    const galleryElement = this.refs.detail;
    this.setState({
      loading: imagesLoaded(galleryElement),
    });
  }

  checkOtherEvents() {
    if (this.state.data.hasOwnProperty('next_events') && this.state.data.next_events.length > 0) {
      let listEvents = this.state.data.next_events.map((item) => {
        return (
          <SmallEventCard key={`related-match-` + item.pk} name={item.title} lang={this.lang}
                     start={item.start} description={item.description} photo={item.photo}
                     slug={item.slug} rest={this.restaurant} pk={item.pk} cat={item.category}/>
        );
      });
      return (
        <div className="suggested-area">
          <FormattedMessage id="other_events">
            {(message) => <h6>{message}</h6>}
          </FormattedMessage>
          {listEvents}
        </div>
      );
    }
  }

  updateDimensions() {
    if(window.innerWidth > 1024) {
      this.setState({detail_width: window.innerWidth - 120});
    }
    else {
      this.setState({detail_width: window.innerWidth});
    }
  }

  render() {


    // CHECKING FOR ERRORS FROM THE API
    if (this.state.data.status !== "error") {
      return (
        <div>
          <PreLoader loading={this.state.loading}/>

          <div className={'item-detail content-wrapper ' + this.state.loading}
               style={{width: this.state.detail_width}} ref="detail" onLoad={this.handleLoading.bind(this)}>
            <div className="btn-wrapper">
              <button className="btn body-back-btn" onClick={this.props.history.goBack}/>
            </div>
            <div className="detail-half">
              <div className="card main-card">
                <EventItem name={this.state.data.title} image={this.state.data.display_image}
                          description={this.state.data.description} itemSlug={this.slug} list="false"
                          loading={this.handleLoading} lang={this.lang} start={this.state.data.start}
                          end={this.state.data.end}
                />
                <div ref="addthis" className="addthis_inline_share_toolbox"/>
              </div>
            </div>
            <div className="detail-half">
              <div className="suggested-area">
                <FormattedMessage id="event_link">
                  {(message) => <h6>{message}</h6>}
                </FormattedMessage>
                <a className="event-link" target="_blank" href={this.state.data.url}>{this.state.data.url}</a>
              </div>
              {this.checkOtherEvents()}
            </div>
          </div>
        </div>
      );
    }
    return (
      <Error restaurant={this.restaurant} lang={this.lang} />
    );
  }
}

export default EventDetail;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/EventDetail.js
 **/